import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { ErrorBoundary } from '@shared/components/ErrorBoundary';
import { ToastContainer } from '@shared/components/Toast';
import { useToastStore } from '@shared/stores/toastStore';
import { ApiClientError } from '@shared/api/client';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        if (error instanceof ApiClientError) {
          if (error.status === 403) {
            useToastStore.getState().addToast(error.message, 'warning');
          } else if (error.status === 409) {
            useToastStore.getState().addToast('Already decided from another interface', 'warning');
          } else if (error.status === 429) {
            useToastStore.getState().addToast('Too many requests. Please wait.', 'warning');
          } else {
            useToastStore.getState().addToast(error.message, 'error');
          }
        }
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        <ToastContainer />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
